// extracted by mini-css-extract-plugin
export default {"nowrap":"---------packages-corgi-x-src-components-Nowrap-Nowrap-module__nowrap"};